import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "d-flex justify-content-end"
}
const _hoisted_2 = { class: "table table-responsive-md border border-gray" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "User"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "table-loading" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_9 = ["colspan"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "No Preadmission Notes.", -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "table-error"
}
const _hoisted_13 = ["colspan"]
const _hoisted_14 = {
  key: 2,
  class: "d-flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientPreadmissionNotesForm = _resolveComponent("PatientPreadmissionNotesForm")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_PatientPreadmissionNotesRow = _resolveComponent("PatientPreadmissionNotesRow")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Preadmission Notes",
    "full-height": false,
    "application-id": _ctx.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", {
        class: "d-flex flex-column px-3 py-2",
        style: _normalizeStyle({ width: _ctx.isPreadmissionDialog ? '900px' : '' })
      }, [
        (_ctx.showNoteForm)
          ? (_openBlock(), _createBlock(_component_PatientPreadmissionNotesForm, {
              key: 0,
              application: _ctx.application,
              "is-referral": _ctx.isReferral,
              "referral-id": _ctx.referralId,
              "reset-list": _ctx.resetList,
              referral: _ctx.referral,
              closeNoteFormProp: _ctx.closeNoteForm,
              ref: "preadmissionForm",
              class: "mb-2"
            }, null, 8 /* PROPS */, ["application", "is-referral", "referral-id", "reset-list", "referral", "closeNoteFormProp"]))
          : _createCommentVNode("v-if", true),
        (!_ctx.showNoteForm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.isReferral)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary ms-2 mb-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openNoteForm()))
                  }, " Add Preadmission Note "))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Pagination, {
          ref: "notesList",
          "page-changed": _ctx.pageChangedCallback,
          "is-loading": _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createElementVNode("table", _hoisted_2, [
              _hoisted_3,
              (_ctx.isLoading || _ctx.isError || !_ctx.hasData)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                    _createCommentVNode(" LOADING "),
                    (_ctx.isLoading)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                          return (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                              return (_openBlock(), _createElementBlock("td", null, _hoisted_7))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" EMPTY "),
                    (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                          _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_11, 8 /* PROPS */, _hoisted_9)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" ERROR "),
                    (!_ctx.isLoading && _ctx.isError)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                          _createElementVNode("td", { colspan: _ctx.columns }, [
                            _createVNode(_component_ErrorMessageHandler, {
                              title: "Preadmission Notes",
                              "try-again": _ctx.resetList
                            }, null, 8 /* PROPS */, ["try-again"])
                          ], 8 /* PROPS */, _hoisted_13)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.page.items, (note) => {
                    return (_openBlock(), _createBlock(_component_PatientPreadmissionNotesRow, {
                      note: note,
                      "is-referral": _ctx.isReferral,
                      columns: _ctx.columns,
                      "reset-list": _ctx.resetList,
                      "referral-id": _ctx.referralId,
                      referral: _ctx.referral
                    }, null, 8 /* PROPS */, ["note", "is-referral", "columns", "reset-list", "referral-id", "referral"]))
                  }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["page-changed", "is-loading"]),
        (_ctx.isPreadmissionDialog)
          ? (_openBlock(), _createElementBlock("footer", _hoisted_14, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog())),
                type: "button",
                class: "btn btn-xs me-2 btn-outline-primary"
              }, " Close ")
            ]))
          : _createCommentVNode("v-if", true)
      ], 4 /* STYLE */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}